(function () {
  function formatClock(ms) {
    var totalSeconds = Math.max(0, Math.floor(ms / 1000));
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
  }

  function initTimer(el) {
    var minutes = parseFloat(el.getAttribute('data-minutes')) || 10;
    var deadline = Date.now() + minutes * 60 * 1000;

    var clockEl = el.querySelector('[data-urgency-timer-clock]');
    var bannerEl = el.querySelector('[data-urgency-timer-banner]');
    var expiredEl = el.querySelector('[data-urgency-timer-expired]');
    var intervalId;

    function tick() {
      var remaining = deadline - Date.now();
      if (remaining <= 0) {
        if (bannerEl) bannerEl.hidden = true;
        if (expiredEl) expiredEl.hidden = false;
        if (intervalId) clearInterval(intervalId);
        return;
      }
      if (clockEl) clockEl.textContent = formatClock(remaining);
    }

    tick();
    intervalId = setInterval(tick, 1000);
  }

  function initAllTimers() {
    var els = document.querySelectorAll('[data-urgency-timer]');
    for (var i = 0; i < els.length; i++) {
      initTimer(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllTimers);
  } else {
    initAllTimers();
  }

  document.addEventListener('shopify:section:load', initAllTimers);
})();
